import _ from "lodash";
window._ = _;

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from "axios";
import { addSsrfProtection } from "./utils/axiosSecurityConfig";

window.axios = axios;
window.axios.defaults.withCredentials = true;
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
window.axios.defaults.headers.common["X-Smaug-Panel"] = "1";
window.axios.defaults.headers.common["Accept"] = "application/json";
window.axios.defaults.headers.common["Content-Type"] = "application/json";

// Add SSRF protection to prevent absolute URL attacks
// This validates all requests to ensure they don't bypass intended API endpoints
addSsrfProtection(window.axios);

import vapor from "laravel-vapor";
window.Vapor = vapor;
